import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const IconContainer = styled.div`
  display: flex;
  margin-top: auto;
`;
